module.exports = __webpack_public_path__ + "img/Mrs-Wyton.f511591f.jpg";